<template>
  <div class="outer">

    <van-icon class="back" name="arrow-left" size=".5rem" color="#fff" @click="navigateBack"></van-icon>
    <img class="backToHome" src="@/assets/img/goods_detail/ic_home.png"
         @click="isInApp ? backMainActivity() : toMyHome()" alt="backHome">

    <div class="content">
      <div class="success-sign">
        <img src="@/assets/img/self_service_room/booked/phone_door.png" alt>
        <div class="hint">预约申请成功！</div>
      </div>
      <div class="booked-room">
        <div class="title">{{getCityName()}} · {{buildings.buildings_name}}</div>
<!--        <div class="title">深圳 · 龙园大观</div>-->
        <div class="room-list">
          <div class="list-wrapper" :class="{scrollPadding: buildings.house_list.length>5}">
            <div class="room" v-for="room in buildings.house_list" v-if="room.checked">{{room.address_info + getTime(room.date)}}</div>
          </div>
<!--          <div class="list-wrapper">
            <div class="room" v-for="room in ['一个', '两个', '三个']">{{room}}</div>
          </div>-->
        </div>
      </div>
    </div>

    <div class="contact">
      <div class="title">
        <div>{{isInWechat ? '请长按二维码' : '请用微信扫一扫'}}</div>
        <div>添加魔方屋官方客服微信获取开门密码！</div>
      </div>
      <div class="service">
        <div class="qr-code">
          <img src="@/assets/img/self_service_room/booked/nationwide_service_qr_code.png" alt>
          <div class="txt">魔方屋全国客服</div>
        </div>
        <div class="qr-code">
          <img src="@/assets/img/self_service_room/booked/shandong_service_qr_code.png" alt>
          <div class="txt">山东大区客服</div>
        </div>
      </div>
    </div>

    <div class="download" v-if="!isInApp">
      <div class="title">下载魔方屋APP</div>
      <div class="txt">
        选择房号获取你家全屋整配<br/>
        软装设计方案及报价
      </div>
      <div class="btn" @click="openApp">立即下载</div>
    </div>

    <cover
      ref="openBrowser"
      :show.sync="showOpenBrowser"
    ></cover>

  </div>
</template>

<script>
import store from "@/vuex/store";
import {houseShowGetList} from "@/api/api";
import utils from "@/jslib/utils";
import Cover from "@/component/cover/cover";
export default {
  name: "Booked",
  components: {Cover},
  data(){
    return{
      isInApp: utils.getPlatform().mfhApp,
      isInWechat: utils.getPlatform().weChat,
      buildings: {
        house_list: []
      },
      buildings_id: '',
      room_arr_str: '',

      showOpenBrowser: false,
    }
  },
  created() {

    this.setToken()

    this.buildings_id = this.$route.query.buildings_id
    this.room_arr_str = this.$route.query.room_arr_str

    if(store.state.pageParam && store.state.pageParam.buildings){
      this.buildings = store.state.pageParam.buildings
    }
    if(!this.buildings.house_list.length) this.network().houseShowGetList()
  },
  methods:{
    getCityName(){
      return utils.getSimplifyAddrName(this.buildings.city)
    },
    openApp(){
      if(utils.getPlatform().ios){
        location.href = 'https://apps.apple.com/cn/app/id1519967100?mt=1'
      }else{
        this.$refs.openBrowser.openApp()
      }
    },
    getTime(timestamp){
      return timestamp ? utils.getTimeStr(timestamp, ' YYYY.MM.dd hh:mm') : ' '
    },
    network(){
      return{
        houseShowGetList: async () => {
          let {data} = await houseShowGetList()
          console.log('获取可预约房间信息', data)

          let {code, message} = data
          if(code == 200){
            this.handler().houseShowGetList(data.data)
          }else {
            this.$uihelper.toast(message)
          }
        }
      }
    },
    handler(){
      return{
        houseShowGetList: (data) => {
          if(data){

            let buildingsList = data.list || []
            for(let i in buildingsList){
              if(buildingsList[i].buildings_id == this.buildings_id){
                this.buildings = buildingsList[i]
                break
              }
            }

            if(this.buildings){
              for(let i in this.buildings.house_list){
                let room = this.buildings.house_list[i]
                let selectedArr = this.room_arr_str.split(',')

                for(let j in selectedArr){
                  let [id, date] = selectedArr[j].split('time:')
                  if(id == room.house_show_id){
                    Object.assign(this.buildings.house_list[i], {checked: true})
                    this.$set(this.buildings.house_list, i, {...this.buildings.house_list[i], checked: true})
                    this.$set(this.buildings.house_list, i, {...this.buildings.house_list[i], date})
                  }
                }

               /* if(roomIdArr.includes(''+room.house_show_id)){
                  Object.assign(this.buildings.house_list[i], {checked: true})
                  this.$set(this.buildings.house_list, i, {...this.buildings.house_list[i], checked: true})
                  this.$set(this.buildings.house_list, i, {...this.buildings.house_list[i], date: appointmentStrArr[i].split('time:')[0]})
                }*/
              }
            }

          }else{
            console.log('未获取到可预约房间信息')
            this.$uihelper.toast('未获取到可预约房间信息')
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "booked";
</style>
